(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-about-team"] && !Shopify.designMode) return;
  try {
    
  class MmxAboutTeam {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('[data-team-track]');
      this.controls = element.querySelector('[data-team-controls]');
      this.prevButton = element.querySelector('[data-team-prev]');
      this.nextButton = element.querySelector('[data-team-next]');
      this.dotsWrapper = element.querySelector('[data-team-dots]');
      this.dots = [];
      this.slides = [];
      this.pageOffsets = [0];
      this.pageCount = 1;
      this.activePage = 0;

      if (!this.track) return;

      this.onScroll = this.debounce(() => this.syncFromScroll(), 80);
      this.onResize = this.debounce(() => this.build(), 150);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);

      // Catches width changes the window resize misses — the section being
      // revealed after load, or the theme editor resizing the preview frame.
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.track);
      }

      this.prevButton?.addEventListener('click', () => this.goTo(this.activePage - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.activePage + 1));

      this.bindQuoteToggles();
      this.build();
    }

    debounce(fn, wait) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    // Tap-to-reveal for the quote overlay; desktop also reveals on hover via CSS.
    bindQuoteToggles() {
      this.element.querySelectorAll('[data-team-quote-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const card = toggle.closest('.mmx-about-team__card');
          const isOpen = card.classList.toggle('is-quote-open');
          toggle.setAttribute('aria-expanded', String(isOpen));
        });
      });
    }

    get maxScroll() {
      return this.track.scrollWidth - this.track.clientWidth;
    }

    build() {
      this.slides = Array.from(this.track.querySelectorAll('.mmx-about-team__slide'));
      this.pageOffsets = this.buildPageOffsets();
      this.pageCount = this.pageOffsets.length;

      if (this.controls) this.controls.hidden = this.pageCount < 2;

      this.renderDots();
      this.syncFromScroll();
    }

    // Distance from the start of the scrollable content to each slide's left
    // edge, first slide included: the gutter mobile leaves in front of it is
    // part of the scroll range, so measuring every slide against slide 1 (as
    // offsetLeft differences do) would land the centred cards a gutter short.
    measureSlideStarts() {
      const trackLeft = this.track.getBoundingClientRect().left;
      const scrollLeft = this.track.scrollLeft;

      return this.slides.map((slide) => slide.getBoundingClientRect().left - trackLeft + scrollLeft);
    }

    // Cards a page advances by — the count the stylesheet is laying out, read
    // straight off it. Deriving it from the track width instead lets the dots
    // disagree with the screen: a measurement a card or two too wide silently
    // pages in threes, so the last cards get no dot and the arrows stop early.
    get perView() {
      const declared = parseInt(
        getComputedStyle(this.element).getPropertyValue('--mmx-about-team-per-view'),
        10
      );

      return declared > 0 ? declared : 1;
    }

    // How far into the scrollport a centred card sits. That is exactly the
    // runway the stylesheet leaves after the last card, so reading it back
    // keeps the two in agreement — and gives 0 wherever cards snap to the
    // start, which is the same arithmetic with no inset.
    get centerInset() {
      const isCentered = (getComputedStyle(this.slides[0]).scrollSnapAlign || '').includes('center');
      if (!isCentered) return 0;

      return parseFloat(getComputedStyle(this.slides[this.slides.length - 1]).marginRight) || 0;
    }

    // One page per group of cards, keyed to the scroll offset the track can
    // actually reach: the cards are sized so a page doesn't always divide into
    // what's left, so the final page lands short of its nominal offset and no
    // dot would ever match it.
    buildPageOffsets() {
      const maxScroll = this.maxScroll;
      if (this.slides.length < 2 || maxScroll <= 1) return [0];

      const starts = this.measureSlideStarts();
      const step = starts[1] - starts[0];
      if (step <= 0) return [0];

      const perView = this.perView;
      const inset = this.centerInset;
      const offsets = [];

      for (let i = 0; i < this.slides.length; i += perView) {
        // Clamped the same way the browser clamps a scroll-snap position that
        // sits outside the scroll range — which is what parks the first card on
        // the gutter rather than centring it. Clamping can leave the last page
        // a few pixels from the one before it, so drop pages that wouldn't move
        // the track by a meaningful fraction of a card.
        const offset = Math.max(0, Math.min(starts[i] - inset, maxScroll));
        if (offsets.length === 0 || offset - offsets[offsets.length - 1] > step / 4) offsets.push(offset);
      }

      return offsets;
    }

    renderDots() {
      if (!this.dotsWrapper) return;

      this.dotsWrapper.innerHTML = '';
      this.dots = [];

      if (this.pageCount < 2) return;

      for (let i = 0; i < this.pageCount; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mmx-about-team__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Go to slide group ${i + 1}`);
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsWrapper.appendChild(dot);
        this.dots.push(dot);
      }
    }

    goTo(page) {
      const target = Math.max(0, Math.min(page, this.pageCount - 1));
      this.track.scrollTo({ left: this.pageOffsets[target], behavior: 'smooth' });
    }

    syncFromScroll() {
      const maxScroll = this.maxScroll;
      const scrollLeft = this.track.scrollLeft;

      this.activePage = this.pageOffsets.reduce(
        (closest, offset, index) =>
          Math.abs(offset - scrollLeft) < Math.abs(this.pageOffsets[closest] - scrollLeft) ? index : closest,
        0
      );

      // The end of the track is always the last page, even when a free swipe
      // leaves it nearer the previous page's offset.
      if (maxScroll > 1 && scrollLeft >= maxScroll - 1) this.activePage = this.pageCount - 1;

      this.dots.forEach((dot, index) => {
        const isActive = index === this.activePage;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });

      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 1;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 1;
    }
  }

  function initMmxAboutTeam(element) {
    if (element.dataset.mmxAboutTeamReady === 'true') return;
    element.dataset.mmxAboutTeamReady = 'true';
    new MmxAboutTeam(element);
  }

  document.querySelectorAll('[data-mmx-about-team]').forEach(initMmxAboutTeam);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mmx-about-team]').forEach((element) => {
      element.dataset.mmxAboutTeamReady = '';
      initMmxAboutTeam(element);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-article-slider"] && !Shopify.designMode) return;
  try {
    
  class MmxArticleSlider {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('[data-slider-track]');
      this.controls = element.querySelector('[data-slider-controls]');
      this.prevButton = element.querySelector('[data-slider-prev]');
      this.nextButton = element.querySelector('[data-slider-next]');
      this.dotsWrapper = element.querySelector('[data-slider-dots]');
      this.dots = [];
      this.slides = [];
      this.pageOffsets = [0];
      this.pageCount = 1;
      this.activePage = 0;

      // Loop state. Desktop centres one card and the design wants an article
      // showing either side of it, including on the very first card — so the
      // track is padded with clones and teleported back to the middle copy
      // whenever the reader crosses into one.
      this.isLooping = false;
      this.copies = 1;
      this.middleCopy = 0;
      this.step = 0;

      if (!this.track) return;

      // The slides the section rendered. Clones are always built from these, so
      // a rebuild can never end up cloning a clone.
      this.realSlides = Array.from(this.track.children);
      this.realCount = this.realSlides.length;

      this.onScroll = this.debounce(() => this.onScrollSettled(), 120);
      this.onResize = this.debounce(() => this.build(), 150);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);

      // Catches width changes the window resize misses — the section being
      // revealed after load, or the theme editor resizing the preview frame.
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.track);
      }

      this.prevButton?.addEventListener('click', () => this.advance(-1));
      this.nextButton?.addEventListener('click', () => this.advance(1));

      this.build();
    }

    // Puts the real slides back before letting go, so the markup the editor
    // tears down is the markup the section rendered.
    destroy() {
      if (!this.track) return;

      this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.resizeObserver?.disconnect();

      if (this.isLooping) {
        this.track.replaceChildren(...this.realSlides);
        this.track.classList.remove('is-looping');
        this.isLooping = false;
      }
    }

    debounce(fn, wait) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    get maxScroll() {
      return this.track.scrollWidth - this.track.clientWidth;
    }

    // The stylesheet decides whether this breakpoint loops — desktop centres a
    // single card and wants neighbours either side of it, mobile scrolls a
    // plain start-aligned list.
    get loopRequested() {
      return (
        parseInt(getComputedStyle(this.element).getPropertyValue('--mmx-article-slider-loop'), 10) === 1
      );
    }

    build() {
      const active = this.isLooping ? this.activePage : null;

      this.layoutLoop();
      this.slides = Array.from(this.track.children);

      if (this.isLooping) {
        this.pageCount = this.realCount;
        this.pageOffsets = [];
        if (this.controls) this.controls.hidden = false;
        this.renderDots();
        // A rebuild throws the scroll position away, so put the card the reader
        // was on back under the centre.
        this.jumpToPosition(this.middleCopy * this.realCount + (active ?? 0));
      } else {
        this.pageOffsets = this.buildPageOffsets();
        this.pageCount = this.pageOffsets.length;
        if (this.controls) this.controls.hidden = this.pageCount < 2;
        this.renderDots();
      }

      this.syncFromScroll();
    }

    // Enough copies of the article set that the centred card always has a
    // neighbour either side, and that the middle copy's cards can all reach the
    // centre without the browser clamping them against the end of the track.
    requiredCopies() {
      const cardWidth = this.realSlides[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = cardWidth + gap;
      const viewport = this.track.clientWidth;

      if (step <= 0 || viewport <= 0) return 1;

      // Room a centred card needs on either side of it: half the scrollport,
      // less its own half, plus the gap that follows the last card in a copy.
      const runway = viewport / 2 + cardWidth / 2 + gap;
      const half = Math.max(1, Math.ceil(runway / (step * this.realCount)));

      return 2 * half + 1;
    }

    layoutLoop() {
      const wantsLoop = this.loopRequested && this.realCount > 1;
      const copies = wantsLoop ? this.requiredCopies() : 1;

      // Guard against a huge DOM on a very wide window with very few articles.
      if (!wantsLoop || copies < 3 || copies * this.realCount > 60) {
        if (this.isLooping) {
          this.track.replaceChildren(...this.realSlides);
          this.track.classList.remove('is-looping');
          this.isLooping = false;
          this.copies = 1;
          this.middleCopy = 0;
        }
        return;
      }

      if (this.isLooping && copies === this.copies) return;

      const middle = Math.floor(copies / 2);
      const nodes = [];

      for (let copy = 0; copy < copies; copy += 1) {
        for (let index = 0; index < this.realCount; index += 1) {
          const slide = this.realSlides[index];
          nodes.push(copy === middle ? slide : this.cloneSlide(slide));
        }
      }

      this.track.replaceChildren(...nodes);
      this.track.classList.add('is-looping');
      this.isLooping = true;
      this.copies = copies;
      this.middleCopy = middle;
    }

    // Clones are decoration: hidden from assistive tech, out of the tab order,
    // and stripped of the editor hooks that must stay unique to the real slide.
    cloneSlide(slide) {
      const clone = slide.cloneNode(true);

      clone.dataset.sliderClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      clone.querySelectorAll('a, button').forEach((element) => element.setAttribute('tabindex', '-1'));

      return clone;
    }

    // Distance from the start of the scrollable content to each slide's left
    // edge, first slide included: the gutter mobile leaves in front of it is
    // part of the scroll range, so measuring every slide against slide 1 (as
    // offsetLeft differences do) would land the pages a gutter short.
    measureSlideStarts() {
      const trackLeft = this.track.getBoundingClientRect().left;
      const scrollLeft = this.track.scrollLeft;

      return this.slides.map((slide) => slide.getBoundingClientRect().left - trackLeft + scrollLeft);
    }

    // Cards a page advances by — the count the stylesheet is laying out, read
    // straight off it so the dots can never disagree with the screen.
    get perView() {
      const declared = parseInt(
        getComputedStyle(this.element).getPropertyValue('--mmx-article-slider-per-view'),
        10
      );

      return declared > 0 ? declared : 1;
    }

    // How far into the scrollport a snapped card sits, read back off the
    // stylesheet so the two can never disagree. Centred cards (desktop) sit
    // half the leftover width in. Start-aligned cards (mobile) sit the
    // snapport's own inset in.
    get snapInset() {
      const align = getComputedStyle(this.slides[0]).scrollSnapAlign || '';

      if (align.includes('center')) {
        const cardWidth = this.slides[0].getBoundingClientRect().width;
        return Math.max(0, (this.track.clientWidth - cardWidth) / 2);
      }

      return parseFloat(getComputedStyle(this.track).scrollPaddingLeft) || 0;
    }

    // One page per group of cards, keyed to the scroll offset the track can
    // actually reach: a page doesn't always divide into what's left, so the
    // final page lands short of its nominal offset and no dot would match it.
    buildPageOffsets() {
      const maxScroll = this.maxScroll;
      if (this.slides.length < 2 || maxScroll <= 1) return [0];

      const starts = this.measureSlideStarts();
      const step = starts[1] - starts[0];
      if (step <= 0) return [0];

      const perView = this.perView;
      const inset = this.snapInset;
      const offsets = [];

      for (let i = 0; i < this.slides.length; i += perView) {
        // Clamped the way the browser clamps a snap position outside the scroll
        // range. Clamping can leave the last page a few pixels from the one
        // before it, so drop pages that wouldn't move the track meaningfully.
        const offset = Math.max(0, Math.min(starts[i] - inset, maxScroll));
        if (offsets.length === 0 || offset - offsets[offsets.length - 1] > step / 4) offsets.push(offset);
      }

      return offsets;
    }

    renderDots() {
      if (!this.dotsWrapper) return;

      this.dotsWrapper.innerHTML = '';
      this.dots = [];

      if (this.pageCount < 2) return;

      for (let i = 0; i < this.pageCount; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mmx-article-slider__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute(
          'aria-label',
          this.isLooping ? `Go to article ${i + 1}` : `Go to slide group ${i + 1}`
        );
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsWrapper.appendChild(dot);
        this.dots.push(dot);
      }
    }

    // Loop geometry ------------------------------------------------------

    // Width one card advances by. Measured between two neighbours rather than
    // added up from card width and gap, so sub-pixel widths stay honest.
    measureStep() {
      if (this.slides.length < 2) return 0;

      const starts = this.measureSlideStarts();
      return starts[1] - starts[0];
    }

    // Scroll offset that parks the slide at `position` under the centre.
    offsetForPosition(position) {
      return position * this.step - this.snapInset;
    }

    // Which slide the track is currently parked on.
    positionFromScroll() {
      if (this.step <= 0) return this.middleCopy * this.realCount;

      const raw = (this.track.scrollLeft + this.snapInset) / this.step;
      return Math.max(0, Math.min(Math.round(raw), this.slides.length - 1));
    }

    // Teleport, with nothing for the reader to notice. Smooth scrolling has to
    // come off because the stylesheet asks for it on the track itself, so the
    // jump would otherwise animate; snapping comes off so the browser cannot
    // re-snap to where it was parked before the clones moved under it.
    jumpTo(left) {
      const { style } = this.track;

      style.scrollSnapType = 'none';
      style.scrollBehavior = 'auto';
      this.track.scrollLeft = left;
      // Read back so the new position is committed before snapping resumes.
      void this.track.offsetWidth;
      style.scrollBehavior = '';
      style.scrollSnapType = '';
    }

    glideTo(left) {
      this.track.scrollTo({ left, behavior: 'smooth' });
    }

    jumpToPosition(position) {
      this.step = this.measureStep();
      if (this.step <= 0) return;

      this.jumpTo(this.offsetForPosition(position));
    }

    // Navigation ----------------------------------------------------------

    advance(direction) {
      if (!this.isLooping) {
        this.goTo(this.activePage + direction);
        return;
      }

      this.glideTo(this.offsetForPosition(this.positionFromScroll() + direction));
    }

    goTo(page) {
      if (this.isLooping) {
        const target = ((page % this.realCount) + this.realCount) % this.realCount;

        // Re-anchor to the middle copy first so the run to the target can never
        // overshoot the ends of the track.
        this.jumpToPosition(this.middleCopy * this.realCount + this.activePage);
        this.glideTo(this.offsetForPosition(this.middleCopy * this.realCount + target));
        return;
      }

      const target = Math.max(0, Math.min(page, this.pageCount - 1));
      this.glideTo(this.pageOffsets[target]);
    }

    // Once the track has come to rest, pull it back into the middle copy so
    // there is always another copy's worth of cards to scroll into either way.
    onScrollSettled() {
      this.syncFromScroll();

      if (!this.isLooping) return;

      const position = this.positionFromScroll();
      const home = this.middleCopy * this.realCount + this.activePage;

      if (position !== home) this.jumpToPosition(home);
    }

    syncFromScroll() {
      if (this.isLooping) {
        this.step = this.measureStep();
        this.activePage =
          ((this.positionFromScroll() % this.realCount) + this.realCount) % this.realCount;

        // A loop has no ends to run out of.
        if (this.prevButton) this.prevButton.disabled = false;
        if (this.nextButton) this.nextButton.disabled = false;
      } else {
        const maxScroll = this.maxScroll;
        const scrollLeft = this.track.scrollLeft;

        this.activePage = this.pageOffsets.reduce(
          (closest, offset, index) =>
            Math.abs(offset - scrollLeft) < Math.abs(this.pageOffsets[closest] - scrollLeft) ? index : closest,
          0
        );

        // The end of the track is always the last page, even when a free swipe
        // leaves it nearer the previous page's offset.
        if (maxScroll > 1 && scrollLeft >= maxScroll - 1) this.activePage = this.pageCount - 1;

        if (this.prevButton) this.prevButton.disabled = scrollLeft <= 1;
        if (this.nextButton) this.nextButton.disabled = maxScroll <= 1 || scrollLeft >= maxScroll - 1;
      }

      this.dots.forEach((dot, index) => {
        const isActive = index === this.activePage;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    }
  }

  const mmxArticleSliders = new WeakMap();

  function initMmxArticleSlider(element) {
    if (element.dataset.mmxArticleSliderReady === 'true') return;
    element.dataset.mmxArticleSliderReady = 'true';
    mmxArticleSliders.set(element, new MmxArticleSlider(element));
  }

  function destroyMmxArticleSlider(element) {
    mmxArticleSliders.get(element)?.destroy();
    mmxArticleSliders.delete(element);
    element.dataset.mmxArticleSliderReady = '';
  }

  document.querySelectorAll('[data-mmx-article-slider]').forEach(initMmxArticleSlider);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mmx-article-slider]').forEach((element) => {
      destroyMmxArticleSlider(element);
      initMmxArticleSlider(element);
    });
  });

  // The editor drops the section's markup on unload; without this the window
  // listener would keep the old instance, and its observer, alive for the rest
  // of the session.
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mmx-article-slider]').forEach(destroyMmxArticleSlider);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-community"] && !Shopify.designMode) return;
  try {
    
  class MmxCommunityMarquee {
    constructor(element) {
      this.element = element;
      this.viewport = element.querySelector('.mmx-community__viewport');
      this.track = element.querySelector('.mmx-community__track');
      this.prevButton = element.querySelector('[data-community-prev]');
      this.nextButton = element.querySelector('[data-community-next]');
      this.autoscroll = element.dataset.autoscroll !== 'false';
      this.onResize = this.setup.bind(this);
      this.onPrev = () => this.step(-1);
      this.onNext = () => this.step(1);
      this.stepFrame = null;
      this.onPointerDown = this.handlePointerDown.bind(this);
      this.onPointerMove = this.handlePointerMove.bind(this);
      this.onPointerUp = this.handlePointerUp.bind(this);
      this.onDragStart = (event) => event.preventDefault();
      this.onScroll = this.handleScroll.bind(this);
      this.pointerId = null;
      this.setWidth = 0;
      this.loops = false;
    }

    setup() {
      if (!this.viewport || !this.track) return;

      const template = this.track.querySelector('[data-community-set]');
      if (!template) return;

      const templateWidth = template.offsetWidth;
      if (templateWidth === 0) return;

      this.track.querySelectorAll('.mmx-community__set:not([data-community-set])').forEach((set) => set.remove());

      const cloneSet = () => {
        const clone = template.cloneNode(true);
        clone.removeAttribute('data-community-set');
        clone.setAttribute('aria-hidden', 'true');
        return clone;
      };

      this.track.appendChild(cloneSet());

      let safety = 0;
      // Manual mode scrolls within [setWidth, setWidth * 2), so it needs a full set of
      // runway on each side of the viewport to wrap seamlessly in both directions.
      const targetWidth = this.autoscroll
        ? this.viewport.offsetWidth * 2
        : templateWidth * 2 + this.viewport.offsetWidth;

      while (this.track.scrollWidth < targetWidth && safety < 30) {
        this.track.appendChild(cloneSet());
        safety += 1;
      }

      if (this.autoscroll && this.track.children.length % 2 !== 0) {
        this.track.appendChild(cloneSet());
      }

      this.setWidth = templateWidth;
      this.element.style.setProperty('--mmx-community-shift', `${templateWidth}px`);

      if (!this.autoscroll) {
        this.loops = this.track.scrollWidth >= targetWidth;
        this.viewport.scrollLeft = this.loops ? templateWidth : 0;
      }

      this.element.classList.add('is-ready');
    }

    handleScroll() {
      if (!this.loops || !this.setWidth) return;

      const left = this.viewport.scrollLeft;

      if (left >= this.setWidth * 2) {
        this.viewport.scrollLeft = left - this.setWidth;
      } else if (left < this.setWidth) {
        this.viewport.scrollLeft = left + this.setWidth;
      }
    }

    // One card per click, measured live so it tracks the card width and gap.
    cardStep() {
      const cards = this.track.querySelectorAll('.mmx-community__card');
      if (cards.length === 0) return this.viewport.clientWidth;

      if (cards.length > 1) {
        const step = cards[1].offsetLeft - cards[0].offsetLeft;
        if (step > 0) return step;
      }

      return cards[0].offsetWidth;
    }

    step(direction) {
      if (!this.viewport || !this.track) return;

      const distance = this.cardStep() * direction;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.viewport.scrollLeft += distance;
        return;
      }

      cancelAnimationFrame(this.stepFrame);

      const duration = 420;
      const start = performance.now();
      let applied = 0;

      // Scripted rather than scrollTo({ behavior: 'smooth' }): each frame moves
      // scrollLeft by a delta, the way the drag handler does, so the loop wrap
      // in handleScroll can re-anchor mid-animation without cancelling it or
      // dragging the carousel back to where it started.
      const tick = (now) => {
        const progress = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        const target = distance * eased;

        this.viewport.scrollLeft += target - applied;
        applied = target;

        if (progress < 1) this.stepFrame = requestAnimationFrame(tick);
      };

      this.stepFrame = requestAnimationFrame(tick);
    }

    handlePointerDown(event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;

      // A grab takes over from an arrow that is still animating.
      cancelAnimationFrame(this.stepFrame);

      this.pointerId = event.pointerId;
      this.lastX = event.clientX;
      this.element.classList.add('is-grabbing');

      window.addEventListener('pointermove', this.onPointerMove);
      window.addEventListener('pointerup', this.onPointerUp);
      window.addEventListener('pointercancel', this.onPointerUp);
    }

    handlePointerMove(event) {
      if (event.pointerId !== this.pointerId) return;

      event.preventDefault();
      // Tracked incrementally so the loop wrap in handleScroll isn't undone mid-drag.
      this.viewport.scrollLeft += this.lastX - event.clientX;
      this.lastX = event.clientX;
    }

    handlePointerUp(event) {
      if (event.pointerId !== this.pointerId) return;

      this.pointerId = null;
      this.element.classList.remove('is-grabbing');

      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
      window.removeEventListener('pointercancel', this.onPointerUp);
    }

    connect() {
      if (this.autoscroll && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const init = () => {
        this.setup();
        window.addEventListener('resize', this.onResize);

        if (!this.autoscroll && this.viewport) {
          this.viewport.addEventListener('pointerdown', this.onPointerDown);
          this.viewport.addEventListener('dragstart', this.onDragStart);
          this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
          this.prevButton?.addEventListener('click', this.onPrev);
          this.nextButton?.addEventListener('click', this.onNext);
        }
      };

      if (document.fonts?.ready) {
        document.fonts.ready.then(init);
      } else {
        requestAnimationFrame(() => requestAnimationFrame(init));
      }
    }

    disconnect() {
      window.removeEventListener('resize', this.onResize);
      cancelAnimationFrame(this.stepFrame);
      this.handlePointerUp({ pointerId: this.pointerId });
      this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
      this.viewport?.removeEventListener('dragstart', this.onDragStart);
      this.viewport?.removeEventListener('scroll', this.onScroll);
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
    }
  }

  const mmxCommunityMarquees = new WeakMap();

  function initMmxCommunityMarquees(root = document) {
    root.querySelectorAll('[data-mmx-community-marquee]').forEach((element) => {
      mmxCommunityMarquees.get(element)?.disconnect();
      const marquee = new MmxCommunityMarquee(element);
      mmxCommunityMarquees.set(element, marquee);
      marquee.connect();
    });
  }

  initMmxCommunityMarquees();

  document.addEventListener('shopify:section:load', (event) => {
    initMmxCommunityMarquees(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mmx-community-marquee]').forEach((element) => {
      mmxCommunityMarquees.get(element)?.disconnect();
      mmxCommunityMarquees.delete(element);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-marquee"] && !Shopify.designMode) return;
  try {
    
  class MmxMarquee {
    constructor(element) {
      this.element = element;
      this.viewport = element.querySelector('.mmx-marquee__viewport');
      this.track = element.querySelector('.mmx-marquee__track');
      this.onResize = this.setup.bind(this);
    }

    setup() {
      if (!this.viewport || !this.track) return;

      const template = this.track.querySelector('[data-marquee-set]');
      if (!template) return;

      const templateWidth = template.offsetWidth;
      if (templateWidth === 0) return;

      this.track.querySelectorAll('.mmx-marquee__set:not([data-marquee-set])').forEach((set) => set.remove());

      const cloneSet = () => {
        const clone = template.cloneNode(true);
        clone.removeAttribute('data-marquee-set');
        clone.setAttribute('aria-hidden', 'true');
        return clone;
      };

      this.track.appendChild(cloneSet());

      let safety = 0;
      const targetWidth = this.viewport.offsetWidth * 2;

      while (this.track.scrollWidth < targetWidth && safety < 20) {
        this.track.appendChild(cloneSet());
        safety += 1;
      }

      if (this.track.children.length % 2 !== 0) {
        this.track.appendChild(cloneSet());
      }

      this.element.style.setProperty('--mmx-marquee-shift', `${templateWidth}px`);
      this.element.classList.add('is-ready');
    }

    connect() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const init = () => {
        this.setup();
        window.addEventListener('resize', this.onResize);
      };

      if (document.fonts?.ready) {
        document.fonts.ready.then(init);
      } else {
        requestAnimationFrame(() => requestAnimationFrame(init));
      }
    }

    disconnect() {
      window.removeEventListener('resize', this.onResize);
    }
  }

  const mmxMarquees = new WeakMap();

  function initMmxMarquees(root = document) {
    root.querySelectorAll('[data-mmx-marquee]').forEach((element) => {
      mmxMarquees.get(element)?.disconnect();
      const marquee = new MmxMarquee(element);
      mmxMarquees.set(element, marquee);
      marquee.connect();
    });
  }

  initMmxMarquees();

  document.addEventListener('shopify:section:load', (event) => {
    initMmxMarquees(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mmx-marquee]').forEach((element) => {
      mmxMarquees.get(element)?.disconnect();
      mmxMarquees.delete(element);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-testimonials"] && !Shopify.designMode) return;
  try {
    
  class MmxTestimonials {
    constructor(element) {
      this.element = element;
      this.slides = [...element.querySelectorAll('.mmx-testimonials__slide')];
      this.dots = [...element.querySelectorAll('.mmx-testimonials__dot')];
      this.prevButton = element.querySelector('[data-slide-prev]');
      this.nextButton = element.querySelector('[data-slide-next]');
      this.activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      this.autoPlay = element.dataset.autoPlay === 'true';
      this.autoplaySpeed = Number(element.dataset.autoplaySpeed) * 1000 || 5000;
      this.autoplayTimer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.activeIndex < 0) this.activeIndex = 0;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.slideTarget);
          if (!Number.isNaN(index)) {
            this.goTo(index);
            this.restartAutoplay();
          }
        });
      });

      this.prevButton?.addEventListener('click', () => {
        this.prev();
        this.restartAutoplay();
      });

      this.nextButton?.addEventListener('click', () => {
        this.next();
        this.restartAutoplay();
      });

      if (this.autoPlay && this.slides.length > 1 && !this.reducedMotion) {
        this.startAutoplay();
        element.addEventListener('mouseenter', this.handlePause);
        element.addEventListener('mouseleave', this.handleResume);
        element.addEventListener('focusin', this.handlePause);
        element.addEventListener('focusout', this.handleResume);
      }
    }

    handlePause = () => {
      this.stopAutoplay();
    };

    handleResume = () => {
      this.startAutoplay();
    };

    next() {
      if (this.slides.length <= 1) return;
      const nextIndex = (this.activeIndex + 1) % this.slides.length;
      this.goTo(nextIndex);
    }

    prev() {
      if (this.slides.length <= 1) return;
      const prevIndex = (this.activeIndex - 1 + this.slides.length) % this.slides.length;
      this.goTo(prevIndex);
    }

    startAutoplay() {
      if (!this.autoPlay || this.slides.length <= 1 || this.reducedMotion) return;
      this.stopAutoplay();
      this.autoplayTimer = window.setInterval(() => this.next(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    goTo(index) {
      if (index === this.activeIndex || !this.slides[index]) return;

      this.slides[this.activeIndex]?.classList.remove('is-active');
      this.slides[this.activeIndex]?.setAttribute('hidden', '');

      this.activeIndex = index;

      this.slides[this.activeIndex].classList.add('is-active');
      this.slides[this.activeIndex].removeAttribute('hidden');

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    destroy() {
      this.stopAutoplay();
      this.element.removeEventListener('mouseenter', this.handlePause);
      this.element.removeEventListener('mouseleave', this.handleResume);
      this.element.removeEventListener('focusin', this.handlePause);
      this.element.removeEventListener('focusout', this.handleResume);
    }
  }

  const initMmxTestimonials = (element) => {
    if (!element || element._mmxTestimonials) return;
    element._mmxTestimonials = new MmxTestimonials(element);
  };

  document.querySelectorAll('[data-mmx-testimonials]').forEach(initMmxTestimonials);

  document.addEventListener('shopify:section:load', (event) => {
    initMmxTestimonials(event.target.querySelector('[data-mmx-testimonials]'));
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const element = event.target.querySelector('[data-mmx-testimonials]');
    if (element?._mmxTestimonials) {
      element._mmxTestimonials.destroy();
      delete element._mmxTestimonials;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-slideshow-v-2-0"] && !Shopify.designMode) return;
  try {
    
  // Slideshow component
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.ss-slideshow__slide');
      if (this.slides.length <= 1) return;

      this.currentSlideIndicator = this.querySelector('.ss-current-slide-indicator');
      this.currentSlideIndex = this.dataset.activeSlide;
      this.counterControls = this.querySelectorAll('.ss-slideshow-controls__link');

      this.nextControl = this.querySelector('.ss-slideshow-control--next');
      this.previousControl = this.querySelector('.ss-slideshow-control--previous');

      if (this.getAttribute('data-autoplay') === 'true') {
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) * 1000;
        this.isAutoplayButtonSetToPlay = true;
        this.setAutoPlay();
      }

      this.initButtons();
    }

    initButtons() {
      this.nextControl.addEventListener('click', () => {
        this.updateSlideshow('next');
        this.resetAutoPlay();
      });

      this.previousControl.addEventListener('click', () => {
        this.updateSlideshow('previous');
        this.resetAutoPlay();
      });

      this.counterControls.forEach((control) => {
        control.addEventListener('click', () => {
          if (this.currentSlideIndex == control.dataset.slideNumber) return;
          this.updateSlideshow(control.dataset.slideNumber);
          this.resetAutoPlay();
        });
      });
    }

    updateSlideshow(target = 'next') {
      let nextSlideIndex = 0;
      let transitionDirection = target;

      switch (target) {
        case 'next':
          nextSlideIndex = parseInt(this.dataset.activeSlide) + 1;
          break;
        case 'previous':
          nextSlideIndex = parseInt(this.dataset.activeSlide) - 1;
          break;
        default:
          nextSlideIndex = target;
          transitionDirection = nextSlideIndex > this.dataset.activeSlide ? 'next' : 'previous';
          break;
      }

      if (nextSlideIndex < 0) {
        nextSlideIndex = this.slides.length - 1;
      } else if (nextSlideIndex >= this.slides.length) {
        nextSlideIndex = 0;
      }

      this.slideTransition(this.slides[this.dataset.activeSlide], this.slides[nextSlideIndex], transitionDirection);
      this.updateControls(nextSlideIndex);
      this.dataset.activeSlide = nextSlideIndex;
      this.currentSlideIndex = nextSlideIndex;
    }

    slideTransition(currentSlide, nextSlide, transitionDirection) {
      const slideshowControls = this.querySelectorAll('.ss-slideshow-control');
      slideshowControls.forEach((control) => {
        control.setAttribute('disabled', 'true');
      });

      currentSlide.addEventListener('animationend', (event) => {
        if (event.animationName.includes('ssSlideIn')) return;

        // Hide slides & reset transitions
        this.slides.forEach((slide) => {
          slide.setAttribute('aria-hidden', 'true');
          slide.classList.remove(`ss-slide--transition-out-${transitionDirection}`);
        });

        // Set new slide to active
        nextSlide.setAttribute('aria-hidden', 'false');
        nextSlide.classList.remove(`ss-slide--${transitionDirection}`);
        slideshowControls.forEach((control) => {
          control.removeAttribute('disabled');
        });
      });

      // Start slide transition
      currentSlide.classList.add(`ss-slide--transition-out-${transitionDirection}`);
      nextSlide.classList.add(`ss-slide--${transitionDirection}`);
    }

    updateControls(newSlideIndex) {
      // If we have a current slide indicator (i.e. 2/3), update it
      if (this.currentSlideIndicator) {
        this.currentSlideIndicator.innerText = `${newSlideIndex + 1}/${this.slides.length}`;
        return;
      }

      this.counterControls.forEach((control) => {
        control.classList.remove('ss-slideshow-controls__link--active');
      });
      this.counterControls[newSlideIndex].classList.add('ss-slideshow-controls__link--active');
    }

    resetAutoPlay() {
      if (this.isAutoplayButtonSetToPlay) {
        this.play();
      }
    }

    /* Handle autoplay */
    setAutoPlay() {
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));

      this.sliderAutoplayButton = this.querySelector('.ss-slideshow-control--autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.isAutoplayButtonSetToPlay = true;
      this.play();
    }

    autoPlayToggle() {
      this.togglePlayButtonState(this.isAutoplayButtonSetToPlay);
      this.isAutoplayButtonSetToPlay ? this.pause() : this.play();
      this.isAutoplayButtonSetToPlay = !this.isAutoplayButtonSetToPlay;
    }

    togglePlayButtonState(pauseAutoplay) {
      this.sliderAutoplayButton.classList.toggle('ss-slideshow-control--autoplay--paused', pauseAutoplay);
      pauseAutoplay
        ? this.sliderAutoplayButton.setAttribute('aria-label', 'Play slideshow')
        : this.sliderAutoplayButton.setAttribute('aria-label', 'Pause slideshow');
    }

    play() {
      this.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
      this.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }

    autoRotateSlides() {
      this.updateSlideshow('next');
    }

    focusOutHandling(event) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);

      if (this.isAutoplayButtonSetToPlay && !focusedOnAutoplayButton) this.play();
    }

    focusInHandling(event) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);

      if (this.isAutoplayButtonSetToPlay) {
        focusedOnAutoplayButton ? this.play() : this.pause();
      }
    }
  }

  if (!customElements.get('ss-slideshow-component')) {
    customElements.define('ss-slideshow-component', SlideshowComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
